// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  faqs: '/faqs',
  minimalStore: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    signIn: `${ROOTS.AUTH}/sign-in`,
    signUp: `${ROOTS.AUTH}/sign-up`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    overview: `${ROOTS.DASHBOARD}/overview`,
    wallets: `${ROOTS.DASHBOARD}/wallets`,
    transfer: `${ROOTS.DASHBOARD}/transfer`,
    customers: `${ROOTS.DASHBOARD}/customers`,
    transactions: `${ROOTS.DASHBOARD}/transactions`,
    gas: `${ROOTS.DASHBOARD}/gas`,
    webhooks: `${ROOTS.DASHBOARD}/webhooks`,
    treasuryAutoConversion: `${ROOTS.DASHBOARD}/treasury-auto-conversion`,
    keys: `${ROOTS.DASHBOARD}/keys`,
    user: `${ROOTS.DASHBOARD}/user`,
    terminals: `${ROOTS.DASHBOARD}/terminals`,
    transactionsToApprove: `${ROOTS.DASHBOARD}/transactions?tab=to-approve`,
    checkout: {
      root: `${ROOTS.DASHBOARD}/checkout`,
      analytics: `${ROOTS.DASHBOARD}/checkout/analytics`,
      wallets: `${ROOTS.DASHBOARD}/checkout/wallets`,
      transactions: `${ROOTS.DASHBOARD}/checkout/transactions`,
      products: `${ROOTS.DASHBOARD}/checkout/products`,
      sessions: `${ROOTS.DASHBOARD}/checkout/sessions`,
      autoConversion: `${ROOTS.DASHBOARD}/checkout/auto-conversion`,
    },
    invoices: {
      root: `${ROOTS.DASHBOARD}/checkout/invoices`,
      create: `${ROOTS.DASHBOARD}/checkout/invoices/create`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/checkout/invoices/${id}`,
    },
    billing: {
      root: `${ROOTS.DASHBOARD}/billing`,
      total: `${ROOTS.DASHBOARD}/billing/total`,
      history: `${ROOTS.DASHBOARD}/billing/history`,
    },
    reports: {
      root: `${ROOTS.DASHBOARD}/reports`,
      default: `${ROOTS.DASHBOARD}/reports/default`,
      pay: `${ROOTS.DASHBOARD}/reports/pay`,
      payouts: `${ROOTS.DASHBOARD}/reports/payouts`,
      swaps: `${ROOTS.DASHBOARD}/reports/swaps`,
    },
    products: `${ROOTS.DASHBOARD}/checkout/products`,
    nearIntents: {
      root: `${ROOTS.DASHBOARD}/near-intents`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/near-intents/${id}`,
    },
    customerSwaps: {
      root: `${ROOTS.DASHBOARD}/customer-swaps`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/customer-swaps/${id}`,
    },
    swap: {
      root: `${ROOTS.DASHBOARD}/swap`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/swap/${id}`,
    },
    batchPayouts: {
      root: `${ROOTS.DASHBOARD}/batch-payouts`,
      funding: `${ROOTS.DASHBOARD}/batch-payouts/funding`,
      build: `${ROOTS.DASHBOARD}/batch-payouts/build`,
      transactions: `${ROOTS.DASHBOARD}/batch-payouts/transactions`,
      detail: (id: string) => `${ROOTS.DASHBOARD}/batch-payouts/${id}`,
    },
    organization: `${ROOTS.DASHBOARD}/organization`,
  },
};
